<div class="header">
  <img src="{{ 'assets/images/faq/icone-questions.svg' | cheminAbsoluStatique }}" width="35" height="35" alt="" />
  <h2 appFocusOnInit class="title dsd-t-4" id="titre-faq">
    {{ 'faq.btn' | translate }}
  </h2>
  <app-dialog-close-button (buttonClick)="closeModal()"></app-dialog-close-button>
</div>

<div #content class="content" (scroll)="onScroll()">
  <mat-accordion [@.disabled]="isAnimationDisabled">
    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question1
      (opened)="pushEvent(question1Label, 'ouverture')"
      (closed)="pushEvent(question1Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question1.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question1.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p class="dsd-mb-0">
          <span [innerHTML]="'faq.question1.answer' | translate"></span>
          <a
            class="link"
            target="_blank"
            [title]="'faq.question1.lienAlt' | translate"
            [innerHtml]="'faq.question1.lienTexte' | translate"
            [href]="'faq.question1.lien' | translate"
          ></a>
          <span [innerHTML]="'faq.question1.ctcmb.text' | translate"></span>
          <app-boite-contact buttonStyle="textOnly" [buttonText]="'faq.question1.ctcmb.lien'"></app-boite-contact>
        </p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question2
      (opened)="pushEvent(question2Label, 'ouverture')"
      (closed)="pushEvent(question2Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question2.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question2.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p class="dsd-mb-0">
          <span [innerHTML]="'faq.question2.answer' | translate"></span>
          <a
            *ngIf="isPreautNavEnabled"
            class="link"
            target="_blank"
            [innerHtml]="'faq.question2.lienTexte' | translate"
            (click)="goPreaut()"
            (keydown.enter)="goPreaut()"
          ></a>
        </p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question3
      (opened)="pushEvent(question3Label, 'ouverture')"
      (closed)="pushEvent(question3Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question3.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question3.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p [innerHTML]="'faq.question3.answer' | translate"></p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question4
      (opened)="pushEvent(question4Label, 'ouverture')"
      (closed)="pushEvent(question4Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question4.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question4.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p [innerHTML]="'faq.question4.answer' | translate"></p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question5
      (opened)="pushEvent(question5Label, 'ouverture')"
      (closed)="pushEvent(question5Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question5.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question5.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p [innerHTML]="'faq.question5.answer' | translate"></p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question6
      (opened)="pushEvent(question6Label, 'ouverture')"
      (closed)="pushEvent(question6Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question6.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question6.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p class="dsd-mb-0" [innerHTML]="'faq.question6.answer' | translate"></p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question7
      (opened)="pushEvent(question7Label, 'ouverture')"
      (closed)="pushEvent(question7Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question7.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question7.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p [innerHTML]="'faq.question7.answer' | translate"></p>
      </ng-template>
    </mat-expansion-panel>

    <mat-divider class="divider"></mat-divider>

    <mat-expansion-panel
      class="mat-elevation-z0"
      [class.mat-expansion-panel-spacing]="false"
      hideToggle
      #question8
      (opened)="pushEvent(question8Label, 'ouverture')"
      (closed)="pushEvent(question8Label, 'fermeture')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="dsd-mb-0 dsd-fw-bold" [innerHTML]="'faq.question8.question' | translate"></p>
        </mat-panel-title>
        <img
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          class="arrow"
          [ngClass]="{ up: question8.expanded }"
          alt=""
          width="12"
          height="22"
        />
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <p class="dsd-mb-0">
          <span [innerHTML]="'faq.question8.answer' | translate"></span>
          <a
            class="link"
            target="_blank"
            [title]="'faq.question8.lienAlt' | translate"
            [innerHtml]="'faq.question8.lienTexte' | translate"
            [href]="'faq.question8.lien' | translate"
          ></a>
        </p>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="fade" [class.visible]="isFadeVisible"></div>

<div class="footer">
  <button mat-button class="green accessible" id="btn-fermer" (click)="closeModal()">
    {{ 'btn.fermer' | translate }}
  </button>
</div>
